import Dropdown from 'ui/Dropdown'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Content, Earning, Purchases, ReleaseDate, SerieTitle,  } from '../columns'
import { Table } from 'ui'

const RowSerie = ({
  uuid,
  title,
  cover,
  status,
  releaseDate,
  purchases,
  earnings,
  isShutDown
}) => {

  const { t } = useTranslation()

  return (
    <Table.Row>
      <Table.Column>
        <Content cover={cover} title={title} />
      </Table.Column>

      <Table.Column />
      <Table.Column />

      <Table.Column>
        <ReleaseDate
          status={status}
          date={releaseDate}
        />
      </Table.Column>

      <Table.Column>
        <Purchases
          status={status}
          purchases={purchases}
        />
      </Table.Column>

      <Table.Column>
        <Earning
          status={status}
          earnings={earnings}
        />
      </Table.Column>

      <Table.Column>
        <Dropdown
          isShutDown={isShutDown}
          options={[
            {
              label: t('viewOnFlixxo'),
              to: `/series/${uuid}`
            }
          ]}
        />
      </Table.Column>

    </Table.Row>
  )
}

export default RowSerie